import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const MicrophoneOffIcon = ({
  color = colors.white,
  className,
  onClick,
  size = 18,
  ...props
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 10.5V6C15 4.343 13.657 3 12 3C10.6936 3 9.58246 3.83474 9.17067 5M14.4293 13.7607C13.8841 14.5117 12.9991 15 12 15C10.343 15 9 13.657 9 12V8"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 10V12C18 15.314 15.314 18 12 18V18C8.686 18 6 15.314 6 12V10"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18V21"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.82031 21H16.1803"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.25 3.25L19.75 18.75"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MicrophoneOffIcon;
